import { PulseEnvironment } from '../globals';
import { PageInfoService } from './page-info.service';

export class RouteHelperService {
    constructor(
        private env: PulseEnvironment,
        private page: PageInfoService,
    ) {}

    cleanupURL(key: string): void {
        const currentURL = this.page.url();

        if (currentURL.searchParams.has(key)) {
            currentURL.searchParams.delete(key);
            this.env.win.history.replaceState(
                this.env.win.history.state,
                this.env.doc.title,
                currentURL.href,
            );
        }
    }
}
